import React from 'react';
import { Helmet } from 'react-helmet';

import { css } from '@emotion/react';

import { Footer } from '../components/Footer';
import SiteNav from '../components/header/SiteNav';
import { PostFullContent } from '../components/PostContent';
import { Wrapper } from '../components/Wrapper';
import IndexLayout from '../layouts';
import {
  inner,
  outer,
  SiteArchiveHeader,
  SiteHeader,
  SiteMain,
  SiteNavMain,
} from '../styles/shared';
import { NoImage, PostFull, PostFullHeader, PostFullTitle } from '../templates/post';
import { colors } from '../styles/colors';

const PageTemplate = css`
  .site-main {
    margin-top: 64px;
    padding-bottom: 4vw;
    background: #fff;
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>About</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header className="site-archive-header no-image" css={[SiteHeader, SiteArchiveHeader]}>
        <div css={[outer, SiteNavMain]}>
          <div css={inner}>
            <SiteNav/>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <div css={inner}>
          <article className="post page" css={[PostFull, NoImage]}>
            <PostFullHeader className="post-full-header">
              <PostFullTitle className="post-full-title">About</PostFullTitle>
            </PostFullHeader>

            <PostFullContent className="post-full-content">
              <div className="post-content">
                <h5>
                  About us
                </h5>
                <p>
                Our software company focuses on publishing our own software applications and games.
                <br/>
                <br/>
                We have a talented team of experienced software developers who are dedicated to creating high-quality, user-friendly products that we are passionate about.
                <br/>
                <br/>
                Our applications are designed to solve specific problems or meet the needs of our users, and are built using the latest technologies and industry best practices.
                <br/>
                <br/>
                We are committed to delivering exceptional user experiences, and our products are tested extensively to ensure they are reliable and easy to use.
                <br/>
                <br/>
                In addition to creating software applications, we also develop a wide range of engaging and entertaining games. From action-packed adventure games to challenging puzzle games, we have something for every type of player.
                <br/>
                <br/>
                Our games are designed to be enjoyable and addictive, and we are constantly working on new ideas and concepts to keep our players engaged.
                <br/>
                <br/>
                Overall, our goal is to provide our users with exceptional software solutions that meet their needs and exceed their expectations.
                </p>
              </div>
            </PostFullContent>
          </article>
        </div>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
